import React, { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import "./css/Applications.css";
import axios from "./../axios";
import toast from "react-hot-toast";

const Applications = () => {
  const [applications, setApplications] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
 
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('student_token');
      const [testsResponse] = await Promise.all([
        axios.get('student/applications', {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      setApplications(testsResponse.data);
    } catch (error) {
      toast.error("Failed to fetch applications.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (newTitle.trim() && newDescription.trim()) {
      setIsSubmitting(true);
      try {
        const token = localStorage.getItem('student_token');
        await axios.get('student/applications_add', {
          params: {
            title: newTitle,
            description: newDescription,
          },
          headers: { Authorization: `Bearer ${token}` },
        });
        setNewTitle("");
        setNewDescription("");
        toast.success("Application submitted successfully!");
        await fetchData(); // Reload all applications
      } catch (error) {
        toast.error("Failed to submit application.");
      } finally {
        setIsSubmitting(false);
      }
    } else {
      toast.error("Please fill in both title and description.");
    }
  };

  return (
    <>
      <TopBar title="Applications" />
      <div className="applications-container">
        <div className="new-application-section">
          <h2 className="section-title">Send New Application</h2>
          <input
            type="text"
            className="input-field"
            placeholder="Application Title"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            disabled={isSubmitting}
          />
          <textarea
            className="input-field textarea"
            placeholder="Application Description"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
            disabled={isSubmitting}
          ></textarea>
          <button
            className="submit-button"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span>
                <span
                  style={{
                    display: 'inline-block',
                    width: '16px',
                    height: '16px',
                    border: '2px solid #f3f3f3',
                    borderTop: '2px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginRight: '8px',
                    verticalAlign: 'middle',
                  }}
                ></span>
                Submitting...
              </span>
            ) : (
              'Submit Application'
            )}
          </button>
        </div>
        <div className="recent-applications-section">
          <h2 className="section-title">Recent Applications</h2>
          {isLoading ? (
            <div>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  className="application-card"
                  style={{ animation: 'pulse 1.5s infinite' }}
                >
                  <div
                    style={{
                      height: '20px',
                      background: '#e0e0e0',
                      borderRadius: '4px',
                      marginBottom: '10px',
                    }}
                  ></div>
                  <div
                    style={{
                      height: '60px',
                      background: '#e0e0e0',
                      borderRadius: '4px',
                      marginBottom: '10px',
                    }}
                  ></div>
                  <div
                    style={{
                      height: '16px',
                      width: '100px',
                      background: '#e0e0e0',
                      borderRadius: '4px',
                    }}
                  ></div>
                </div>
              ))}
            </div>
          ) : applications.length === 0 ? (
            <p className="no-applications">No applications yet.</p>
          ) : (
            applications.map((app) => (
              <div key={app.id} className="application-card">
                <h3 className="application-title">{app.title}</h3>
                <p className="application-description">{app.description}</p>
                <p className="application-date">{app.date}</p>
                <p>
                  Status:{' '}
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '14px',
                      ...(app.status === 0
                        ? { color: '#f1c40f', background: '#fef9e7' } // Pending
                        : app.status === 1
                        ? { color: '#2ecc71', background: '#e8f5e9' } // Approved
                        : { color: '#e74c3c', background: '#fdedec' }), // Rejected
                    }}
                  >
                    <span
                      style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background:
                          app.status === 0
                            ? '#f1c40f'
                            : app.status === 1
                            ? '#2ecc71'
                            : '#e74c3c',
                      }}
                    ></span>
                    {app.status === 0
                      ? 'Pending'
                      : app.status === 1
                      ? 'Approved'
                      : 'Rejected'}
                  </span>
                </p>
              </div>
            ))
          )}
        </div>
      </div>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default Applications;